export default "__VITE_ASSET__f302ac7d__"